<script setup lang="ts">
import type { VideoData } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

defineProps<{
  data?: VideoData;
  componentStyles?: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <div class="container flex flex-col items-center gap-8 xl:flex-row xl:gap-24">
      <div class="video-container w-full">
        <BaseVideo :video-data="data" />
      </div>

      <div
        v-if="data.headline || data.subline || data.cta"
        class="max-w-xl text-center"
      >
        <BaseScrollTransition content-class="flex flex-col justify-center content-container">
          <h3
            v-if="data.headline"
            class="text-2xl mb-4"
          >
            {{ data.headline }}
          </h3>
          <p
            v-if="data.subline"
            class="mb-8 text-lg"
          >
            {{ data.subline }}
          </p>

          <BaseButton
            v-if="data.cta"
            class="w-max self-center"
            :to="data.cta.url"
            :target="data.cta.target"
          >
            {{ data.cta.name }}
          </BaseButton>
        </BaseScrollTransition>
      </div>
    </div>
  </BaseComponentWrapper>
</template>
